
const m = window.require("ember-testing/lib/test/pending_requests");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
